const EXTERNAL_ORDER_CONFIRMATION_TYPE_ALIBABA = 'alibaba'
const EXTERNAL_ORDER_CONFIRMATION_TYPE_ALIEXPRESS = 'aliexpress'
const EXTERNAL_ORDER_CONFIRMATION_TYPE_DRAFT_ORDERS = 'draft_orders'

export {
  EXTERNAL_ORDER_CONFIRMATION_TYPE_ALIBABA,
  EXTERNAL_ORDER_CONFIRMATION_TYPE_ALIEXPRESS,
  EXTERNAL_ORDER_CONFIRMATION_TYPE_DRAFT_ORDERS
}
